var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9366 8.00183L12.4633 4.47516C12.7233 4.21516 12.7233 3.79516 12.4633 3.53516C12.2033 3.27516 11.7833 3.27516 11.5233 3.53516L7.9966 7.06183L4.46996 3.5285C4.20996 3.2685 3.78996 3.2685 3.52996 3.5285C3.26996 3.7885 3.26996 4.2085 3.52996 4.4685L7.0566 8.00183L3.52996 11.5285C3.26996 11.7885 3.26996 12.2085 3.52996 12.4685C3.65663 12.6018 3.82329 12.6685 3.99663 12.6685C4.16996 12.6685 4.33663 12.6018 4.46996 12.4752L7.9966 8.94183L11.5233 12.4685C11.6566 12.6018 11.8233 12.6685 11.9966 12.6685C12.1699 12.6685 12.3366 12.6018 12.4699 12.4752C12.7299 12.2152 12.7299 11.7952 12.4699 11.5352L8.9366 8.00183Z",
    fill: "#2845EA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.5d4ef91c.svg";
export { ForwardRef as ReactComponent };